import { TranslateParser, TranslateService } from '@ngx-translate/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';
import { HelperService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class CustomMatPaginatorInt extends MatPaginatorIntl {
  private rangeLabelIntl: string;

  constructor(
    private translateService: TranslateService,
    private translateParser: TranslateParser,
    public helperService: HelperService
  ) {
    super();
    this.translateService.onLangChange.subscribe((e: Event) => {
      this.getTranslations();
    });
    this.getTranslations();
  }

  getTranslations() {
    this.translateService
      .get([
        'PAGINATOR.ITEMS_PER_PAGE',
        'PAGINATOR.NEXT_PAGE',
        'PAGINATOR.PREVIOUS_PAGE',
        'PAGINATOR.RANGE',
      ])
      .subscribe(translation => {
        this.itemsPerPageLabel = translation['PAGINATOR.ITEMS_PER_PAGE'];
        this.nextPageLabel = translation['PAGINATOR.NEXT_PAGE'];
        this.previousPageLabel = translation['PAGINATOR.PREVIOUS_PAGE'];
        this.rangeLabelIntl = translation['PAGINATOR.RANGE'];
        this.changes.next();
      });
  }

  getRangeLabel = (page, pageSize, length) => {
    if (this.helperService.mainPerfectScrollbar) {
      this.helperService.mainPerfectScrollbar.update();
    }
    length = Math.max(length, 0);
    let startIndex = page * pageSize;
    const endIndex =
      startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    // The current page index defaults to 0
    startIndex = startIndex + 1;
    return this.translateParser.interpolate(this.rangeLabelIntl, { startIndex, endIndex, length });
  };
}
